<!-- Created by henian.xu on 2020/5/26. -->

<template>
    <Page>
        <Container>
            <template v-if="detail">
                <ScheduleItem
                    :data="detail"
                    no-list
                />
                <CellGroup
                    class="ma-t"
                    border
                >
                    <Cell
                        v-for="item in detail.subjectList"
                        :key="item.appraisalSubject"
                        :label="`${item.appraisalSubjectName}单项考试`"
                        direction="column"
                    >
                        <template #extra>
                            <div class="extra">
                                <div>时间: {{item.examTimeBegin | moment('YYYY-MM-DD HH:mm:ss')}} - {{item.examTimeEnd | moment('YYYY-MM-DD HH:mm:ss')}}</div>
                                <div
                                    v-if="item.examResult"
                                    class="ma-t ta-r tc-base"
                                >成绩: {{item.examResult}}</div>
                            </div>
                        </template>
                    </Cell>
                </CellGroup>
                <CellGroup
                    class="ma-t"
                    border
                >
                    <Cell
                        label="考试说明"
                        direction="column"
                    >
                        <template #extra>
                            <div
                                class="extra"
                                v-html="examDesc || '无'"
                            ></div>
                        </template>
                    </Cell>
                </CellGroup>

                <div
                    v-if="hasTheory"
                    class="paper-list"
                >
                    <div
                        class="item"
                        v-for="(item,index) in examApplyPaperList"
                        :key="index"
                    >
                        <div class="label">
                            <div class="count">第{{index + 1}}次答卷</div>
                            <div
                                v-if="item.examResult"
                                class="score"
                            >{{item.examScore}}分</div>
                        </div>
                        <div class="content">
                            时间: {{ item._timeStr||'未开始' }}
                        </div>
                    </div>
                </div>
            </template>
            <RecognitionDialog
                ref="recognitionDialog"
                show-close-btn
                :params="{recognitionType:1,certExamExamId:(certExamExamDetail||{}).id,certExamApplyId}"
            ></RecognitionDialog>
        </Container>
        <PageBar
            v-if="surplusExamNum"
            position="bottom"
        >
            <XButton
                class="item"
                label="开始考试"
                theme="success"
                :disabled="submitting"
                @click="()=>{onSubmit()}"
            ></XButton>
        </PageBar>
    </Page>
</template>

<script>
import { pageMixin } from 'mixins';
import ScheduleItem from './_ScheduleItem';

export default {
    name: 'Detail',
    mixins: [pageMixin],
    components: { ScheduleItem },
    data() {
        return {
            verticalGroupingId: this.$route.params.id,
            detail: null,
            submitting: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        const { name } = from;
        next(vm => {
            if (name === 'examPaper') {
                vm.getDetail();
            }
        });
    },
    computed: {
        certExamExamDetail() {
            return (this.detail || {}).certExamExamDetail;
        },
        certExamApplyId() {
            return (this.detail || {}).certExamApplyId;
        },
        examNum() {
            const { certExamExamDetail = {} } = this;
            return certExamExamDetail.examNum || 0;
        },
        certExamApplyPaperId() {
            const { certExamExamDetail = {} } = this;
            return certExamExamDetail.certExamApplyPaperId;
        },
        examApplyPaperList() {
            const { certExamExamDetail = {}, examNum } = this;
            if (!examNum) return [];
            const list = (certExamExamDetail.examApplyPaperList || []).map(item => {
                const { beginTime, finishTime } = item;
                const format = 'YYYY-MM-DD HH:mm:ss';
                return {
                    ...item,
                    _timeStr: `${this.$moment(beginTime).format(format)}~${this.$moment(finishTime).format(format)}`,
                };
            });
            const surplusList = Array(examNum - list.length).fill({});
            return list.concat(surplusList);
        },
        surplusExamNum() {
            return this.examApplyPaperList.reduce((pre, cur) => {
                return pre + (cur.id ? 0 : 1);
            }, 0);
        },
        hasTheory() {
            // 含理论科目(appraisalSubject=1)时才展示机考成绩
            const { subjectList = [] } = this.detail || {};
            return subjectList.some(item => item.appraisalSubject === 1);
        },
        examDesc() {
            const { detail, certExamExamDetail = {} } = this;
            return certExamExamDetail.examDesc || detail.verticalGroupingDesc || '';
        },
    },
    methods: {
        async getDetail() {
            const { data } = await this.$api.Member.Ce.VerticalGrouping.verticalGroupingDetail(this.verticalGroupingId);
            this.detail = data;
        },
        async createExam() {
            const { certExamApplyId, certExamExamDetail, verticalGroupingId } = this;
            const res = await this.$api.Member.Ce.CertExamPaper.exam(
                {
                    certExamApplyId,
                    certExamExamId: certExamExamDetail.id,
                    verticalGroupingId,
                    paperType: 1,
                },
                {
                    isHandleError: true,
                },
            );
            const { data, success, code, msg } = res;
            if (!success) {
                if (code === 1002) {
                    await this.$refs.recognitionDialog.validate();
                    await this.$nextTick();
                    return this.createExam();
                }
                this.$messageBox.alert(msg);
                return Promise.reject(res);
            }
            return data;
        },
        async onSubmit() {
            const { submitting } = this;
            if (submitting) return;
            this.submitting = true;
            let { certExamApplyPaperId } = this;
            if (certExamApplyPaperId) {
                try {
                    await this.$messageBox.confirm('您有未完成的考试?', '温馨提示', {
                        cancelBtnText: '重新考试',
                        confirmBtnText: '继续考试',
                        isClickOtherClose: false,
                    });
                    await this.$router.push(`/exam/paper/${certExamApplyPaperId}`);
                    setTimeout(() => {
                        this.submitting = false;
                    }, 500);
                    return;
                } catch (e) {
                    // noop
                }
            }
            try {
                certExamApplyPaperId = await this.createExam();
                await this.getDetail();
                this.$router.push(`/exam/paper/${certExamApplyPaperId}`);
            } catch (e) {
                // ;
            }
            setTimeout(() => {
                this.submitting = false;
            }, 500);
        },
    },
    created() {
        this.getDetail();
    },
};
</script>

<style lang="scss" scoped>
.paper-list {
    margin-top: $margin;
    > .item {
        background-color: $color-component-bgc;
        padding: $padding;
        + .item {
            border-top: 1px solid $color-border;
        }

        > .label {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            > .count {
                font-weight: bold;
            }
        }
        > .content {
            margin-top: $margin-small;
            font-size: $little * 100%;
            color: $color-text-minor;
        }
    }
}
</style>
